import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger } from
'./ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section className="block-dark">
      <div className="container">
        <div className="section-header">
          <h2>Preguntas frecuentes</h2>
        </div>

        <div className="faq-container">
          <Accordion type="single" collapsible className="faq-accordion">
            {faqs.map((faq) =>
            <AccordionItem key={faq.id} value={`item-${faq.id}`}>
                <AccordionTrigger className="flex flex-1 items-center justify-between transition-all hover:underline [&[data-state=open]>svg]:rotate-180 faq-question !font-thin !text-xl !text-left py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="faq-answer">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            )}
          </Accordion>
        </div>
      </div>
    </section>);

};

export default FAQ;